import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Imports
import UIWrapper from "../components/UIWrapper";

const ThankYou = () => {
  const navigate = useNavigate();

  {
    /*   useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/my-order");
    }, 3000);

    // Cleanup the timeout when the component unmounts
    return () => clearTimeout(timer);
  }, [navigate]); */
  }

  return (
    <UIWrapper>
      {/* Large Screens */}
      <div className="w-full h-fit bg-whiteColor hidden lg:flex lg:flex-col justify-start items-center p-[5%]">
        <img
          src="/assets/done-icon.gif"
          alt="done-icon"
          className="mb-[2.5%]"
        />
        <p className="font-normal text-[1.25vw] text-textPrimaryColor">
          Your Test Booking Has Been Successfully Received. We Appreciate
        </p>
        <p className="font-normal text-[1.25vw] text-textPrimaryColor mb-[3%]">
          Your Purchase!
        </p>
        <p className="font-normal text-[1vw] text-textPrimaryColor">
          For home collection: As per the scheduled appointment, you will either
          receive a call from the home collection executive or they will arrive
          on time.
        </p>
        <p className="font-normal text-[1vw] text-textPrimaryColor mb-[2.5%]">
          For any concern, mail us on <b>support@finelabs.in</b>
        </p>
        <div className="w-full h-fit flex justify-center items-center space-x-[1.5%] mb-[3%]">
          <button
            className="font-normal text-[1vw] text-primaryColor bg-whiteColor border-2 border-primaryColor rounded-3xl px-[3.5%] py-[0.5%]"
            onClick={() => navigate("/my-order")}
          >
            My Order
          </button>
          <button
            className="font-normal text-[1vw] text-whiteColor bg-primaryColor border-2 border-primaryColor rounded-3xl px-[2.5%] py-[0.5%]"
            onClick={() => navigate("/")}
          >
            Back To Home
          </button>
        </div>
        <img src="/assets/thank-you-large.svg" alt="thank-you" className="" />
      </div>

      {/* Small Screens */}
      <div className="w-full h-fit bg-whiteColor flex flex-col justify-start items-center p-[5%] lg:hidden">
        <img src="/assets/done-icon.gif" alt="done-icon" className="mb-[5%]" />
        <p className="font-normal text-[4.5vw] text-textPrimaryColor text-center">
          Your Test Booking Has Been
        </p>
        <p className="font-normal text-[4.5vw] text-textPrimaryColor text-center">
          Successfully Received. We Appreciate
        </p>
        <p className="font-normal text-[4.5vw] text-textPrimaryColor text-center mb-[6%]">
          Your Purchase!
        </p>
        <p className="font-normal text-[4vw] text-textPrimaryColor text-center">
          For home collection: As per the scheduled appointment, you will either
          receive a call from the home collection executive or they will arrive
          on time.
        </p>
        <p className="font-normal text-[4vw] text-textPrimaryColor text-center">
          For any concern, mail us on
        </p>
        <p className="font-bold text-[4vw] text-textPrimaryColor mb-[5%]">
          support@finelabs.in
        </p>
        <div className="w-full h-fit flex justify-center items-center space-x-[5%] mb-[10%]">
          <button
            className="font-normal text-[4vw] text-primaryColor bg-whiteColor border-2 border-primaryColor rounded-3xl px-[10%] py-[2%]"
            onClick={() => navigate("/my-order")}
          >
            My Order
          </button>
          <button
            className="font-normal text-[4vw] text-whiteColor bg-primaryColor border-2 border-primaryColor rounded-3xl px-[5%] py-[2%]"
            onClick={() => navigate("/")}
          >
            Back To Home
          </button>
        </div>
        <img src="/assets/thank-you-large.svg" alt="thank-you" className="" />
      </div>
    </UIWrapper>
  );
};

export default ThankYou;
